import { useTranslation } from 'react-i18next';
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';
import { Button } from '../../ui/button';
import { FolderOpen, Plus, Loader2 } from 'lucide-react';

const PlanSelector = ({ 
  plans, 
  selectedPlan, 
  loading,
  projects,
  onSelectPlan,
  onCreateNew
}) => {
  const { t } = useTranslation();
  // Get project name for a plan
  const getProjectName = (plan) => {
    if (plan.project_name) return plan.project_name;
    const project = projects.find(p => p.id === plan.project_id);
    return project?.name || 'Unknown Project';
  };

  if (loading) {
    return (
      <Card>
        <CardContent className="py-8">
          <div className="flex items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2">
              <FolderOpen className="h-5 w-5" />
              {t('auto.ctr.projectPlans')}
            </CardTitle>
            <CardDescription>
              {t('auto.ctr.selectAPlanToViewAnd')}
            </CardDescription>
          </div>
          <Button onClick={onCreateNew} data-testid="create-plan-btn">
            <Plus className="h-4 w-4 mr-2" /> {t('auto.ctr.newPlan')}
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {plans.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <FolderOpen className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p>{t('auto.ctr.noProjectPlansCreatedYet')}</p>
            <p className="text-sm mt-1">Click &quot;New Plan&quot; to create one.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {plans.map((plan) => (
              <Button
                key={plan.id}
                variant={selectedPlan?.id === plan.id ? 'default' : 'outline'}
                className="h-auto py-3 flex flex-col items-start text-left"
                onClick={() => onSelectPlan(plan.id)}
                data-testid={`plan-btn-${plan.id}`}
              >
                <span className="font-medium truncate w-full">
                  {plan.name || getProjectName(plan)}
                </span>
                <span className="text-xs opacity-70 truncate w-full">
                  {getProjectName(plan)}
                </span>
                <span className="text-[10px] sm:text-xs opacity-70 truncate w-full">
                  {plan.start_date?.split('T')[0]} - {plan.end_date?.split('T')[0]}
                </span>
              </Button>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PlanSelector;
